'use strict'

const ACCESS_TOKEN_KEY = 'fitmotivation_session'
const REFRESH_TOKEN_KEY = 'fitmotivation_refresh'

// -------------------------
// ACCESS TOKEN
// -------------------------
export function getAccessToken() {
  return localStorage.getItem(ACCESS_TOKEN_KEY)
}

export function setAccessToken(token) {
  localStorage.setItem(ACCESS_TOKEN_KEY, token)
}

export function removeAccessToken() {
  localStorage.removeItem(ACCESS_TOKEN_KEY)
}

// -------------------------
// REFRESH TOKEN
// -------------------------
export function getRefreshToken() {
  return localStorage.getItem(REFRESH_TOKEN_KEY)
}

export function setRefreshToken(token) {
  localStorage.setItem(REFRESH_TOKEN_KEY, token)
}

export function removeRefreshToken() {
  localStorage.removeItem(REFRESH_TOKEN_KEY)
}

// -------------------------
// SESSION HELPERS
// -------------------------
export function setTokens(data) {
  if (data?.token) {
    setAccessToken(data.token)
  }
  if (data?.refresh_token) {
    setRefreshToken(data.refresh_token)
  }
}

export function isLoggedIn() {
  return !!getAccessToken() && !!getRefreshToken()
}

export function hasValidSession() {
  return !!getAccessToken()
}

export function clearSession() {
  removeAccessToken()
  removeRefreshToken()
}

// -------------------------
// HEADERS
// -------------------------
export function getAuthHeaders() {
  const token = getAccessToken()

  if (!token) return {}

  return {
    headers: {
      'X-Access-Token': token
    }
  }
}
